export enum MarketingCampaignStatus {
  Disabled = 0,
  Enabled = 1,
  Paused = 2,
}
